import { __spreadArray } from "tslib";
export var IMAGE_MIME = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'];
export var VIDEO_MIME = [
    'video/3gpp',
    'video/H264',
    'video/mp4',
    'video/mpeg',
    'video/MPV',
    'video/quicktime',
    'video/raw',
];
/**
 * Mime types accepted by DA, please add per usecase entry if you do need
 * some special case but I doubt you do.
 */
export var MIME_CONFIG = {
    forDeviationSubmit: __spreadArray(__spreadArray([], IMAGE_MIME, true), VIDEO_MIME, true),
    forDeviationStashProtect: __spreadArray([], IMAGE_MIME.filter(function (i) { return i !== 'image/gif'; }), true),
    forDeviationAttachment: ['*'],
    forEditorDropSubmit: __spreadArray([], IMAGE_MIME, true),
    forMediaManager: __spreadArray([], IMAGE_MIME, true),
};
export var mimeTypeToPcpType = function (mime) {
    if (mime === 'image/gif') {
        return 'gif';
    }
    else if (IMAGE_MIME.includes(mime)) {
        return mime.split('/').pop();
    }
    else if (VIDEO_MIME.includes(mime)) {
        return 'video';
    }
    return 'unknown';
};
//# sourceMappingURL=mime.js.map